import React from 'react'
import PriceFormatter from '../../../utils/price-formatter'
import createReactClass from 'create-react-class'
import Price from '../../utils/price';
import { getPercentage } from '../../../utils/percentage';


var ProductListTotal = createReactClass({

	getPriceTotal: function () {

		var price = this.props.items.reduce(function (sum, item) {
			return sum + item.getPrice(10);
		}, 0);		
		return Math.round(price*100)/100;
	},
	getBasePriceTotal: function () {
		var price = 0.0;
		for (var i = 0; i < this.props.items.length; i++) {
			price += this.props.items[i].getBasePrice(10);
		}
		return Math.round(price*100)/100;
	},
	getDiscountPercentage: function () {
		return getPercentage(this.getPriceTotal(), this.getBasePriceTotal());
	},
	getTotalNumberOfItems: function () {
		var quantity = 0;
		for (var i = 0; i < this.props.items.length; i++) {
			quantity += this.props.items[i].getQuantity();
		}
		return quantity;
	},
	getDescription: function () {
		if(sessionStorage.channel === "albelli.de") {
			return <a href={sessionStorage.shippingFaqUrl} rel="noreferrer" target="_blank">{sessionStorage.description}</a>
		} else {
			return sessionStorage.description
		}
	},
	render: function() {
		return (
			<div className="ope-section__footer__summary row">
				<span className="ope-section__footer__quantity small-8 medium-8 columns">{_("You’re ordering %s photos", this.getTotalNumberOfItems())} </span>
				<span className="ope-section__footer__total small-2 medium-2 columns">{_("Total")}*</span>
				<span className="small-2 medium-2 columns ope-section__footer__price ope-grid-column-nopadding">
					<Price
						price={this.getBasePriceTotal()}
						discountedPrice={this.getPriceTotal()}
						discount={this.getDiscountPercentage()}
						showAsterisk={sessionStorage && sessionStorage.showAsterisk === "true"}
					></Price>
				</span>
				{sessionStorage &&
					<div className="ope-section__footer__description">
						*{this.getDescription()}
					</div>
				}
			</div>
		);

	}
});

export default ProductListTotal;
